import React, { Component } from "react";
import PropTypes from "prop-types";
import { formatDateTime } from "../../../../utils";
import RightPanel from "../../../common/RightPanel";
import InfoBlock from "../../../common/InfoBlock";

export default class ActionDetails extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    header: PropTypes.string,
  };

  static defaultProps = {
    header: "RightPanelHeader.screenPauseDetails",
    statusChanges: [],
  };

  handleFormCancel = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  renderPanelContent = () => {
    const { actionType, statusChanges, timeZone } = this.props;
    const filteredList = statusChanges.filter(({ status }) => status === actionType);

    if (filteredList.length !== 0) {
      return statusChanges
        .filter(({ status }) => status === actionType)
        .map((item) => (
          <InfoBlock
            cardType="secondary"
            config={[
              {
                title: "Date Range",
                // No toDate means no resume date yet, so only the start date is shown.
                value: [
                  formatDateTime(item.fromDate, "MMM DD, YYYY", false, timeZone),
                  formatDateTime(item.toDate, "MMM DD, YYYY", false, timeZone),
                ]
                  .filter(Boolean)
                  .join(" to "),
                size: {
                  lg: 12,
                  md: 12,
                  sm: 12,
                },
              },
              {
                title: "Reason",
                value: item.reason,
                size: {
                  lg: 12,
                  md: 12,
                  sm: 12,
                },
              },
              {
                title: "Notes",
                value: item.notes,
                size: {
                  lg: 12,
                  md: 12,
                  sm: 12,
                },
              },
            ]}
          />
        ));
    }

    return <div>No {actionType} Data Found</div>;
  };

  render = () => {
    const { isOpen, header } = this.props;

    return (
      <RightPanel
        isOpen={isOpen}
        onClose={() => this.handleFormCancel()}
        header={header}
        showFooter={false}
      >
        {this.renderPanelContent()}
      </RightPanel>
    );
  };
}
